import { HttpClient } from '../HttpClient';
/**
 * * GetJob Request Organizations
 */

export const GetJobRequestOrganizations = async () => {
  try {
    const { data } = await HttpClient.get('api/jobrequisitions/organizations');
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
